module.exports = __webpack_public_path__ + "img/logo.4ab0aa22.svg";